import { IApplicationState } from '../../types/redux';
import { selectSelectedEntitiesCount } from './selectSelectedEntitiesCount';

export const selectIsAllEntitiesSelected = (state: IApplicationState) => {
  const selectedCount = selectSelectedEntitiesCount(state);

  return selectedCount === state.results.favoriteEntities.length;
};
